var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-link",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true,
        },
        on: {
          showEdit: _vm.initCurrentData,
          storeEdit: _vm.storeBlock,
          closeEdit: _vm.initCurrentData,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _vm.currentType === "external"
                    ? _c("div", [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.currentUrl,
                              target: "_blank",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "cw-link external",
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "cw-link-title",
                                  },
                                  [_vm._v(_vm._s(_vm.currentTitle))]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentType === "internal"
                    ? _c(
                        "div",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "CoursewareStructuralElement",
                                  params: {
                                    id: _vm.currentTarget,
                                  },
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "cw-link internal",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "cw-link-title",
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.currentTitle) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Titel")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentTitle,
                                    expression: "currentTitle",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.currentTitle,
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.currentTitle = $event.target.value
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Art des Links")]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentType,
                                      expression: "currentType",
                                    },
                                  ],
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.currentType = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "external",
                                      },
                                    },
                                    [_c("translate", [_vm._v("Extern")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "internal",
                                      },
                                    },
                                    [_c("translate", [_vm._v("Intern")])],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.currentType === "external",
                                  expression: "currentType === 'external'",
                                },
                              ],
                            },
                            [
                              _c("translate", [_vm._v("URL")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentUrl,
                                    expression: "currentUrl",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.currentUrl,
                                },
                                on: {
                                  change: _vm.fixUrl,
                                  input: function input($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.currentUrl = $event.target.value
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.currentType === "internal",
                                  expression: "currentType === 'internal'",
                                },
                              ],
                            },
                            [
                              _c("translate", [_vm._v("Seite")]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentTarget,
                                      expression: "currentTarget",
                                    },
                                  ],
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.currentTarget = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                _vm._l(_vm.courseware, function (el, index) {
                                  return _c(
                                    "option",
                                    {
                                      key: index,
                                      domProps: {
                                        value: el.id,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(el.attributes.title) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _c(
                    "p",
                    [_c("translate", [_vm._v("Informationen zum Link-Block")])],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }